import React from 'react'

class AnnotationDroplist extends React.Component {
  constructor(props) {
    super(props)
    this.dropdown = React.createRef();
  }

  componentDidMount() {
    $(this.dropdown.current).dropdown()
  }

  readAnnotationTypes(){
    const types = $.map(this.props.annotationTypes, (a) => {
      return a.label
    });
    let uniqTypes = [...new Set(types)]
    return $.map(uniqTypes, (t, i) => {
      if (i == 0){
        return (
          <span key={i}>
            <li>
              <a className="black-text" data-label={t} onClick={this.props.onSelect} href="javascript:;">{t}</a>
            </li>
            <li className="divider"></li>
          </span>
        )
      } else {
        return (
          <li key={i}>
            <a className="black-text" data-label={t} onClick={this.props.onSelect} href="javascript:;">{t}</a>
          </li>
        )
      }
    });
  }

  render() {
    const content = this.readAnnotationTypes();
    const dropLocation = this.props.dropLocation || ""
    return (
      <div className="d-flex flex-column col-2">
        <a className="dropdown-button text-white pt-1" data-activates="anotation-types-drop" ref={this.dropdown}>
          <i className="material-icons">more_vert</i>
        </a>
        <ul className={`${dropLocation} dropdown-content dropdown-content-top-0`} style={{'width': '140px'}} id="anotation-types-drop">
          {content}
        </ul>
      </div>
    )
  }
}

export default AnnotationDroplist
